import React from "react";
import ContactForm from "../components/contactForm";

// Add phone number here
// Format: country code + number
// Example: 91xxxxxxxxxx
const phoneNumber = "91xxxxxxxxxx";

const ContactFormPage = () => {
	const handleFormSubmit = (formData) => {
		// This will be the message content sent to User via WhatsApp
		// %0a is used for line breaks in WhatsApp message (i.e. new line (or \n))
		const messageContent = `Subject: *${formData.subject}*%0aMessage:%0a${formData.message}%0a%0aName: ${formData.name}%0aEmail: ${formData.email}%0aPhone: ${formData.phone}`;
		const link = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${messageContent}`;

		const linkElement = document.createElement("a");
		linkElement.href = link;
		linkElement.target = "_blank";
		linkElement.click();
	};

	return (
		<div id="contact-form">
			<ContactForm
				showTitle={true}
				title="Leave a message"
				onSubmit={handleFormSubmit}
				showWatermark={false}
			/>
		</div>
	);
};

export default ContactFormPage;
